import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';

// elvispos
import { SAMService } from 'src/app/sam/sam.service';
import { ConfigService } from 'src/app/config.service';
import { SAMMessage } from 'src/app/sam/interfaces/sam-message';
import { ThemeService } from 'ngx-elvis-ds';
import { BasePage, Helpers } from 'ngx-elvis-ds';
import { ScanditService } from 'src/app/services/scandit.service';
import { ZBarService } from '../../../services/zbar.service';
import { scanImageData } from 'zbar.wasm';
import { CartService } from '../../../services/cart.service';
import { SoundService } from '../../../services/sound.service';

const sleep = (ms: number) => new Promise(r => { setTimeout(r, ms) });

@Component({
  selector: 'app-camera-dialog',
  templateUrl: './camera-dialog.page.html',
  styleUrls: ['./camera-dialog.page.scss'],
})
export class CameraDialogPage extends BasePage implements AfterViewInit {

  @ViewChild('videoRef', { static: true }) 
  video!: ElementRef;

  @ViewChild('canvasRef', { static: true }) 
  canvas!: ElementRef;

  isScanning: boolean = false;
  doubleScanDelay: number = 2000;
  lastScans: Set<string> = new Set();

  constructor(
    public themeSvc: ThemeService,
    private modalCtrl: ModalController,
    private zBarSvc: ZBarService,
    private samSvc: SAMService,
    private cartSvc: CartService,
    private soundSvc: SoundService,
  ) {
    super();
  }

  async ngAfterViewInit() {
  }

  onCallback() {
    this.modalCtrl.dismiss();
  }

  async ngOnInit() {
    try {
      await this.init();
      while (true) {
        await this.scan();
        await sleep(300);
      }
    } catch (err) {
      console.error('cannot get camera', err);
    }
  }

  onActivate() {
    this.isScanning = true;
    console.log('onActivate', this.isScanning)
  }
  
  onDeactivate() {
    this.isScanning = false;
    console.log('onDeactivate', this.isScanning)
  }

  // private 

  private async init() {
    window.onresize = this.handleResize;
    const mediaStream = await navigator.mediaDevices.getUserMedia({
      audio: false,
      video: {
        facingMode: 'environment',
        width: { max: 1280 },
        height: { max: 1280 }
      }
    });
    this.video.nativeElement.srcObject = mediaStream;
    this.video.nativeElement.setAttribute('playsinline', '');
    this.video.nativeElement.play();
    await new Promise(r => {
      this.video.nativeElement.onloadedmetadata = r;
    });
    this.handleResize();
  };

  private async scan() {
    const width = this.video.nativeElement.videoWidth;
    const height = this.video.nativeElement.videoHeight;
    this.canvas.nativeElement.width = width;
    this.canvas.nativeElement.height = height;
    const ctx = this.canvas.nativeElement.getContext('2d');
    ctx!.drawImage(this.video.nativeElement, 0, 0, width, height);
    const imgData = ctx.getImageData(0, 0, width, height);
    const res = await scanImageData(imgData);
    this.render(res);
  }

  private async render(symbols: any) {
    const ctx = this.canvas.nativeElement.getContext('2d');
    const width = this.canvas.nativeElement.width;
    const height = this.canvas.nativeElement.height;

    ctx.clearRect(0, 0, width, height);

    if (!this.isScanning) {
      return;
    }

    ctx.font = '20px serif';
    ctx.strokeStyle = '#FF8C00';
    ctx.fillStyle = '#ff0000';
    ctx.lineWidth = 6;

    for (let i = 0; i < symbols.length; ++i) {
      const sym = symbols[i];
      const scannedBarcode = sym.decode();

      console.log(`#${i}: Type: ${sym.typeName}; Value: ${scannedBarcode}; DoubleScan: ${this.lastScans.has(scannedBarcode)}`)

      if (this.lastScans.has(scannedBarcode)) {
        continue;
      } else {
        const points = sym.points;
        ctx.beginPath();
        for (let j = 0; j < points.length; ++j) {
          const { x, y } = points[j];
          if (j === 0) {
            ctx.moveTo(x, y);
          } else {
            ctx.lineTo(x, y);
          }
        }

        ctx.closePath();
        ctx.stroke();
        // ctx.fillText('#' + i, points[0].x, points[0].y - 10);
        this.lastScans.add(scannedBarcode);

        this.soundSvc.play('barcode-scanner');

        this.samSvc.onSend({
          Command: 'LOOKUP',
          Val: scannedBarcode,
          parms: {
            Qty: this.cartSvc.counters.qty
          }
        });

        setTimeout(() => {
          this.lastScans.delete(scannedBarcode);
        }, this.doubleScanDelay);
      }
    }
  };

  private handleResize() {
    const width = document.documentElement.clientWidth;
    const height = document.documentElement.clientHeight;

    this.video.nativeElement.width = width;
    this.video.nativeElement.height = height;
    this.canvas.nativeElement.width = this.video.nativeElement.videoWidth;
    this.canvas.nativeElement.height = this.video.nativeElement.videoHeight;

    // if (width / this.video.nativeElement.videoWidth < height / this.video.nativeElement.videoHeight) {
    //   this.canvas.nativeElement.style.width = '100%';
    //   this.canvas.nativeElement.style.height = 'auto';
    // } else {
    //   this.canvas.nativeElement.style.width = 'auto';
    //   this.canvas.nativeElement.style.height = '100%';
    // }
  };
}
